import React from "react"
import InformationPage from "../components/information-page"
export default function EditorialPage() {
  return (
    <InformationPage
      title="How Our Guides Are Prepared"
      description="How School Calendar uses sources, AI assistance, worked examples and review dates, and how to report a correction."
    >
      <p>
        School Calendar publishes product instructions and practical planning
        guides. This page explains the nature and limits of that material.
      </p>
      <h2>Sources and examples</h2>
      <p>
        Study-skills and family guidance link to supporting research or
        organisations where relevant. Sources support particular claims; a
        citation does not mean that its publisher endorses School Calendar or an
        example timetable. We distinguish learning research from our own
        suggested routines.
      </p>
      <p>
        Sample families, classroom timetables, prompts and practice weeks
        illustrate how a plan could work. They are not accounts of measured
        results or customer testimonials unless explicitly identified as such.
      </p>
      <h2>Product instructions</h2>
      <p>
        Calendar guides describe specific actions such as reviewing generated
        events, exporting a file and republishing a shared view. Product screens
        and behaviour can change. A source-code check is not the same as an
        end-to-end test; we do not claim independent certification or testing of
        every third-party app.
      </p>
      <h2>AI assistance</h2>
      <p>
        AI tools have assisted with drafting, editing, code and illustrations on
        this website. That assistance is not an expert review or evidence for a
        factual claim. Read the linked sources, check generated calendar events
        before saving them, and adapt examples to your situation.
      </p>
      <h2>Dates and responsibility</h2>
      <p>
        A content review date records an editorial review, not the date a page
        was first published or a review by a qualified health professional.
        Publication and update dates are shown only when established. Resource
        collection dates describe a particular feed or selection, not
        necessarily the article itself.
      </p>
      <p>
        Articles are credited to schoolcalendar.me, with School Calendar as the
        publisher. Personal authorship or specialist qualifications are
        identified only when confirmed; a guide without a named specialist
        should not be interpreted as specialist advice.
      </p>
      <h2>Corrections</h2>
      <p>
        To flag a problem, contact the project through its{" "}
        <a href="https://www.facebook.com/schoolcalendar">Facebook page</a> or{" "}
        <a href="https://www.linkedin.com/company/school-calendar-me">
          LinkedIn page
        </a>
        . Include the article link, the wording in question and a supporting
        source if available. Do not send private calendar details or information
        about a child.
      </p>
      <p>
        <a href="/about/">About School Calendar</a> ·{" "}
        <a href="/guides/">Browse guides</a>
      </p>
    </InformationPage>
  )
}
